export default "__VITE_ASSET__CCvAuY3n__"